<template>
  <div class="sf-site">
    <loading-cmp />
    <error-cmp />
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import LoadingCmp from "./components/ui/LoadingCmp.vue";
import ErrorCmp from "./components/ui/ErrorCmp.vue";

export default defineComponent({
  // test that commit and pull works on server
  components: { LoadingCmp, ErrorCmp },
});

</script>
